<template>

    <div
        class="shop-single-item-container mt-5 pt-4"
    >

        <div class="row">
            <div class="col-12 d-flex flex-column align-items-center recycle-block">

                <div class="sidenav__footer-right d-flex align-items-center mb-4">
                    <a class="d-flex" :class="lang == 'it' ? 'pointer-events-none' : 'active'" :href="lang != 'it' ? translateUrl('it') : 'javascript:void(0)'">IT</a>
                    <div class="sidenav__footer-separator d-flex mx-2"></div>
                    <a class="d-flex" :class="lang == 'en' ? 'pointer-events-none' : 'active'" :href="lang != 'en' ? translateUrl('en') : 'javascript:void(0)'">EN</a>
                </div>

                <div>
                    <h2 class="h1-like-text text-center mb-4" v-html="$root.translateStringRecycling('title_1')"></h2>
                    <p class="text-center mx-auto gold-like-title shop-like-header__gold-text" v-html="$root.translateStringRecycling('text')"></p>
                </div>

            </div>
            <div class="col-12 mt-5">

                <div class="shop-single-item__content p-0 recycle w-100 text-center">
                    <h3 :class="['h2 text-center text-primary', combinationName ? 'mb-2' : 'mb-4']">
                        {{ productName }}
                    </h3>
                    <h4 v-if="combinationName" class="h4 text-center mb-4 text-primary" v-html="combinationName">
                    </h4>
                </div>

                <p class="text-center mx-auto gold-like-title shop-like-header__gold-text justify-content-center pt-5 pb-2 mb-4" v-html="$root.translateStringRecycling('table-title-1')"></p>

                <template v-for="(element, index) in recycle">

                    <div v-if="element != null && typeof trashDestination[index] != 'undefined' && typeof trashDestination[index]['materials'][element] != 'undefined'" class="table-mobile d-flex flex-column w-100 mx-auto mb-5 d-xl-none px-2">

                        <div class="title-block p-3 bg-lightgold text-center bg-black mb-4">
                            <span class="h6 text-primary text-uppercase d-block fw-normal p-0 m-0">
                                <span class="text-black">{{ trashDestination[index].label[lang] }}</span>
                            </span>
                        </div>

                        <div class="block d-flex">
                            <div class="flex-grow-1 d-flex align-items-center label-td">
                                <span class="simple-text text-secondary text-uppercase text-gold">{{ $root.translateStringRecycling('tipo') }}</span>
                            </div>
                            <div class="d-flex align-items-center justify-content-center content-td">
                                <span class="text-right">{{ trashDestination[index]['materials'][element].label[lang] }}</span>
                            </div>
                        </div>

                        <div class="block d-flex">
                            <div class="flex-grow-1 d-flex align-items-center label-td">
                                <span class="simple-text text-secondary text-uppercase text-gold">{{ $root.translateStringRecycling('simbolo') }}</span>
                            </div>
                            <div class="d-flex align-items-center justify-content-center content-td">
                                <span class="text-right">
                                    <img alt="simbolo" class="my-2" :src="'/images/recycle/' + trashDestination[index]['materials'][element].symbol + '.svg'" :width="trashDestination[index]['materials'][element].symbol == 'misti' ? 90 : 45" height="45" />
                                </span>
                            </div>
                        </div>

                        <div class="block d-flex">
                            <div class="flex-grow-1 d-flex align-items-center label-td">
                                <span class="simple-text text-secondary text-uppercase text-gold">{{ $root.translateStringRecycling('destinazione') }}</span>
                            </div>
                            <div class="d-flex align-items-center justify-content-center content-td">
                                <span class="text-right">{{ trashDestination[index]['materials'][element].destination[lang] }}</span>
                            </div>
                        </div>

                    </div>

                </template>

                <!-- DESKTOP -->

                <table class="table table-striped mx-auto d-none d-xl-table" style="max-width: 1000px">
                    <thead>
                        <tr>
                            <th scope="col" class="text-center py-4 px-4 border-0 bg-gold">
                                <span class="h6 text-primary d-block fw-normal p-0 m-0">
                                    <span class="text-white text-uppercase font-weight-light">{{ $root.translateStringRecycling('macrocategoria') }}</span>
                                </span>
                            </th>
                            <th scope="col" class="text-center py-4 px-4 border-0 bg-gold">
                                <span class="h6 text-primary d-block fw-normal p-0 m-0">
                                    <span class="text-white text-uppercase font-weight-light">{{ $root.translateStringRecycling('tipo') }}</span>
                                </span>
                            </th>
                            <th scope="col" class="text-center py-4 px-4 border-0 bg-gold">
                                <span class="h6 text-primary d-block fw-normal p-0 m-0">
                                    <span class="text-white text-uppercase font-weight-light">{{ $root.translateStringRecycling('simbolo') }}</span>
                                </span>
                            </th>
                            <th scope="col" class="text-center py-4 px-4 border-0 bg-gold">
                                <span class="h6 text-primary d-block fw-normal p-0 m-0">
                                    <span class="text-white text-uppercase font-weight-light">{{ $root.translateStringRecycling('destinazione') }}</span>
                                </span>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <template v-for="(element, index) in recycle">
                            <tr v-if="element != null && typeof trashDestination[index] != 'undefined' && typeof trashDestination[index]['materials'][element] != 'undefined'">
                                <td class="text-center">
                                    <span class="h6 text-primary d-block fw-normal text-uppercase">
                                        <span class="text-black">
                                            {{ trashDestination[index].label[lang] }}
                                        </span>
                                    </span>
                                </td>
                                <td class="text-center">
                                    <span class="text-secondary">
                                        {{ trashDestination[index]['materials'][element].label[lang] }}
                                    </span>
                                </td>
                                <td class="text-center">
                                    <img alt="simbolo" class="my-2" :src="'/images/recycle/' + trashDestination[index]['materials'][element].symbol + '.svg'" :width="trashDestination[index]['materials'][element].symbol == 'misti' ? 90 : 45" height="45" />
                                </td>
                                <td class="text-center">
                                    <span class="text-secondary">{{ trashDestination[index]['materials'][element].destination[lang] }}</span>
                                </td>
                            </tr>
                        </template>
                    </tbody>
                </table>

            </div>
        </div>

    </div>

</template>

<script>

    export default {
        props: ['lang', 'product', 'combinationId'],
        data() {
            return {
                trashDestination: {
                    bottiglia: {
                        label: {
                            it: 'Bottiglia',
                            en: 'Bottle',
                            de: 'Flasche'
                        },
                        materials: {
                            'incolore': {
                                label: {
                                    it: 'Vetro incolore',
                                    en: 'Colorless glass',
                                    de: 'Farbloses Glas'
                                },
                                symbol: 'gl-70',
                                destination: {
                                    it: 'Raccolta vetro',
                                    en: 'Glass collection',
                                    de: 'Glassammlung'
                                },
                            },
                            'verde-blu': {
                                label: {
                                    it: 'Vetro verde e blu',
                                    en: 'Green and blue glass',
                                    de: 'Grünes und blaues Glas'
                                },
                                symbol: 'gl-71',
                                destination: {
                                    it: 'Raccolta vetro',
                                    en: 'Glass collection',
                                    de: 'Glassammlung'
                                },
                            },
                            'marrone': {
                                label: {
                                    it: 'Vetro marrone',
                                    en: 'Brown glass',
                                    de: 'Braunes Glas'
                                },
                                symbol: 'gl-72',
                                destination: {
                                    it: 'Raccolta vetro',
                                    en: 'Glass collection',
                                    de: 'Glassammlung'
                                },
                            },
                        }
                    },
                    tappo: {
                        label: {
                            it: 'Tappo',
                            en: 'Cork',
                            de: 'Kork'
                        },
                        materials: {
                            sughero: {
                                label: {
                                    it: 'Sughero',
                                    en: 'Cork',
                                    de: 'Kork'
                                },
                                symbol: 'for-51',
                                destination: {
                                    it: 'Raccolta indifferenziata',
                                    en: 'Undifferentiated collection',
                                    de: 'UndifferenzierUndifferenzierte Sammlungte Sammlung'
                                },
                            },
                            'vite-alluminio': {
                                label: {
                                    it: 'Tappi a vite in alluminio',
                                    en: 'Aluminum screw caps',
                                    de: 'Schraubkappen aus Aluminium'
                                },
                                symbol: 'c-alu-90',
                                destination: {
                                    it: 'Raccolta alluminio',
                                    en: 'Aluminum collection',
                                    de: 'SchraubkappeAluminium Sammlungn aus Aluminium'
                                },
                            },
                            sintetici: {
                                label: {
                                    it: 'Tappi sintetici',
                                    en: 'Synthetic corks',
                                    de: 'Synthetische Korken'
                                },
                                symbol: 'ldpe-4',
                                destination: {
                                    it: 'Raccolta plastica',
                                    en: 'Plastic collection',
                                    de: 'Plastik SammlungPlastik Sammlung'
                                },
                            },
                            misti: {
                                label: {
                                    it: 'Tappi sintetici / sughero',
                                    en: 'Synthetic caps / cork',
                                    de: 'Synthetische Kappen / Kork'
                                },
                                symbol: 'misti',
                                destination: {
                                    it: 'Raccolta plastica o Raccolta indifferenziata',
                                    en: 'Plastic or Undifferentiated collection',
                                    de: 'Kunststoff oder undifferenzierte Sammlung'
                                },
                            }
                        }
                    },
                    capsule: {
                        label: {
                            it: 'Capsula',
                            en: 'Capsule',
                            de: 'Kapsel'
                        },
                        materials: {
                            pvc: {
                                label: {
                                    it: 'Termoretraibili in PVC',
                                    en: 'PVC shrink wrap',
                                    de: 'PVC-Schrumpffolie'
                                },
                                symbol: 'c-pvc-90',
                                destination: {
                                    it: 'Raccolta plastica',
                                    en: 'Plastic collection',
                                    de: 'Plastik Sammlung'
                                },
                            },
                            pet: {
                                label: {
                                    it: 'Termoretraibili in PET',
                                    en: 'PET shrink wrap',
                                    de: 'PET-Schrumpffolie'
                                },
                                symbol: 'c-pet-90',
                                destination: {
                                    it: 'Raccolta plastica',
                                    en: 'Plastic collection',
                                    de: 'Plastik Sammlung'
                                },
                            },
                            stagno: {
                                label: {
                                    it: 'Capsule in stagno',
                                    en: 'Tin capsules',
                                    de: 'Kapseln aus Zinn'
                                },
                                symbol: 'tin-42',
                                destination: {
                                    it: 'Raccolta alluminio',
                                    en: 'Aluminum collection',
                                    de: 'Aluminium Sammlung'
                                },
                            },
                            alluminio: {
                                label: {
                                    it: 'Capsule polilaminato - alluminio',
                                    en: 'Polylaminate capsules - aluminum',
                                    de: 'Kapseln aus Polylaminat - Aluminium'
                                },
                                symbol: 'c-alu-90',
                                destination: {
                                    it: 'Raccolta alluminio',
                                    en: 'Aluminum collection',
                                    de: 'Aluminium Sammlung'
                                },
                            },
                            ceralacca: {
                                label: {
                                    it: 'Capsule in ceralacca',
                                    en: 'Wax capsules',
                                    de: 'Wachskapseln',
                                },
                                symbol: 'c-pi',
                                destination: {
                                    it: 'Raccolta indifferenziata',
                                    en: 'Undifferentiated collection',
                                    de: 'Undifferenzierte Sammlung',
                                },
                            },
                        }
                    },
                    gabbietta: {
                        label: {
                            it: 'Gabbietta',
                            en: 'Cage',
                            de: 'Käfig'
                        },
                        materials: {
                            acciaio: {
                                label: {
                                    it: 'Termoretraibili in PVC',
                                    en: 'PVC shrink wrap',
                                    de: 'PVC-Schrumpffolie'
                                },
                                symbol: 'fe-40',
                                destination: {
                                    it: 'Raccolta acciaio',
                                    en: 'Steel collection',
                                    de: 'Stahlsammlung'
                                },
                            },
                        }
                    },
                    cartone: {
                        label: {
                            it: 'Cartone',
                            en: 'Cardboard',
                            de: 'Karton'
                        },
                        materials: {
                            cartoni: {
                                label: {
                                    it: 'Cartoni',
                                    en: 'Cardboard',
                                    de: 'Karton'
                                },
                                symbol: 'pap-20',
                                destination: {
                                    it: 'Raccolta carta',
                                    en: 'Paper collection',
                                    de: 'Papier Sammlung'
                                },
                            },
                        }
                    },
                    alveare: {
                        label: {
                            it: 'Alveare',
                            en: 'Hive',
                            de: 'Bienenstock'
                        },
                        materials: {
                            cartoni: {
                                label: {
                                    it: 'Cartoni',
                                    en: 'Cardboard',
                                    de: 'Karton'
                                },
                                symbol: 'pap-21',
                                destination: {
                                    it: 'Raccolta carta',
                                    en: 'Paper collection',
                                    de: 'Papier Sammlung'
                                },
                            },
                        }
                    },
                    cassa: {
                        label: {
                            it: 'Cassa di legno',
                            en: 'Wooden box',
                            de: 'Holzkasten'
                        },
                        materials: {
                            legno: {
                                label: {
                                    it: 'Legno',
                                    en: 'Wood',
                                    de: 'Holz'
                                },
                                symbol: 'for-50',
                                destination: {
                                    it: 'Raccolta indifferenziata',
                                    en: 'Undifferentiated collection',
                                    de: 'Undifferenzierte Sammlung'
                                },
                            },
                        }
                    },
                    lattina: {
                        label: {
                            it: 'Lattina',
                            en: 'Tin head',
                            de: 'Blechkopf'
                        },
                        materials: {
                            lattina: {
                                label: {
                                    it: 'Lattina',
                                    en: 'Tin',
                                    de: 'Zinn'
                                },
                                symbol: 'alu-41',
                                destination: {
                                    it: 'Raccolta alluminio',
                                    en: 'Aluminum collection',
                                    de: 'Aluminium Sammlung'
                                },
                            },
                        }
                    },
                    sacchetto: {
                        label: {
                            it: 'Velina / sacchetto bottiglia',
                            en: 'Paper / Bottle bag',
                            de: 'Papier / Flaschentaschen'
                        },
                        materials: {
                            carta: {
                                label: {
                                    it: 'Carta',
                                    en: 'Paper',
                                    de: 'Papier'
                                },
                                symbol: 'pap-22',
                                destination: {
                                    it: 'Raccolta carta',
                                    en: 'Paper collection',
                                    de: 'Papier Sammlung'
                                },
                            },
                        }
                    },
                    pendaglio: {
                        label: {
                            it: 'Pendaglio',
                            en: 'Pendant',
                            de: 'Anhänger'
                        },
                        materials: {
                            carta: {
                                label: {
                                    it: 'Carta',
                                    en: 'Paper',
                                    de: 'Papier'
                                },
                                symbol: 'pap-22',
                                destination: {
                                    it: 'Raccolta carta',
                                    en: 'Paper collection',
                                    de: 'Papier Sammlung'
                                },
                            },
                        },
                    },
                    astuccio: {
                        label: {
                            it: 'Astuccio',
                            en: 'Case',
                            de: 'Weinkiste'
                        },
                        materials: {
                            cartone: {
                                label: {
                                    it: 'Cartone',
                                    en: 'Cardboard',
                                    de: 'Karton'
                                },
                                symbol: 'pap-20',
                                destination: {
                                    it: 'Raccolta carta',
                                    en: 'Paper collection',
                                    de: 'Papier Sammlung'
                                },
                            },
                        }
                    },
                }
            }
        },
        created() {

        },
        mounted() {
            document.querySelector('body').classList.add('recycle')
        },
        methods: {
            translateUrl(lang) {
                if(lang == 'en') {
                    return window.location.href.replace('/it/', '/en/').replace('/vini/', '/wines/')
                }else{
                    return window.location.href.replace('/en/', '/it/').replace('/wines/', '/vini/')
                }
            }
        },
        computed: {
            productName() {
                return this.product['name'].replace('<br>', ' ')
            },
            combinationName() {
                if (!this.combination) {
                    return null;
                }
                return this.combination['attributes'].map(attr => `<strong>${attr.key_label}</strong>: ${attr.value_label}`).join('<span style="margin: 0 .4em;color:#8d5c65;opacity:.3">&bull;</span>');
            },
            combination() {
                if (this.combinationId) {
                    for (const combination of this.product.combinations) {
                        if (combination.code == this.combinationId) {
                            return combination;
                        }
                    }
                }
            },
            recycle() {
                if (this.combination && this.combination.recycle !== undefined) {
                    return this.combination.recycle;
                }
                return this.product.recycle;
            }
        }
    }

</script>

<style>

    @media (min-width:1800px) {

        .recycle-block .h1-like-text{
            font-size: 4.7rem
        }
    }

    @media (max-width:1440px) {
        .recycle-block .h1-like-text{
            font-size: 4.3rem
        }
    }

    @media (max-width:1199px) {
        .recycle-block .h1-like-text{
            font-size: 4rem
        }
    }

    @media (max-width:991px) {
        .recycle-block .h1-like-text{
            font-size: 3.4rem
        }
    }

    @media (max-width:575px) {
        .recycle-block .h1-like-text{
            font-size: 2.7rem
        }
    }

    @media (max-width:430px) {
        .recycle-block .h1-like-text{
            font-size: 2.4rem
        }
    }

    .recycle-block p{
        max-width:70ch;
        padding-left:15px;
        padding-right: 15px;
    }

    .shop-single-item__content.recycle{
        max-width: 100%;
    }

    th span, td span, .table-mobile *{font-family: "europa", sans-serif;}

    .bg-gold{
        background-color:#dfa877;
    }

    .bg-lightgold{
        background-color: #f2efea
    }

    .h6{
        margin-bottom: 0px;
    }

    .table td, .table th{
        border: 0px;
        vertical-align: middle;
    }

    .table-striped tbody tr:nth-of-type(odd) {
        background-color: #ffffff;
    }

    .table-striped tbody tr:nth-of-type(even) {
        background-color: #f2efea;
    }

    .shop-like-header__gold-text:after{
        display:none;
    }
    .shop-like-header__gold-text{
        border: 0px !important;
        padding: 0px;
    }

    @media (max-width: 767px){
        .gold-like-title {
            font-size: 1.3rem;
        }
    }

    .content-td{
        max-width: 65%;
    }

    .table-mobile{
        width: calc(100% - 30px);
        max-width: 400px;
    }

    @media (max-width: 420px) {
        .table-mobile{
            max-width: 420px;
        }
    }

    body.recycle footer.footer-section, body.recycle .pre-footer, body.recycle nav.navbar{
        display: none !important
    }

</style>
